import { render } from "./Table.vue?vue&type=template&id=37dd3fd4&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=37dd3fd4&lang=scss&scoped=true"
import "./Table.vue?vue&type=style&index=1&id=37dd3fd4&lang=css"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dd3fd4"]])

export default __exports__